export default {
  screens: [
    {
      type: 'intro',
      title: ' Chaumet與日本文化',
      content:
        'Chaumet對日本文化的癡迷可以追溯至品牌創立之初。這種好奇心是相互交流的，因爲許多日本顧客也選擇了Chaumet世家。',
      idYt: 'vGycDLMlTz4',
      videoCover: 'world/japan/video.jpg',
      desktop: {
        cover: 'world/japan/cover-1.jpg'
      },
      mobile: {
        cover: 'world/japan/mobile-cover-1.jpg',
        contentStyle: {
          width: '100%'
        },
        coverStyle: {
          width: '100%',
          bottom: '0%',
          left: '0',
          right: 'inherit',
          position: 'relative'
        }
      }
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/japan/triangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/japan/mobileTriangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg'
      },
      content:
        '創始人尼鐸對瑪麗•安東妮皇后的漆器歎爲觀止，約瑟芬皇后對日本文化精髓情有獨鍾，這便是品牌日本情緣的開端。品牌不斷從日本文化中汲取珠寶設計靈感。<br/><br/> 品牌特別設計打造一高級珠寶系列隆重展示與日本文化的緊密聯繫。'
    },
    {
      type: 'column',
      leftImg: 'world/japan/columnLeft.jpg',
      middleImg: 'world/japan/columnMiddle.jpg',
      rightImg: 'world/japan/columnRight.jpg',
      title: 'Song of Spring',
      content:
        '春之歌（Chant du Printemps）水墨與漆器素雅的色彩，葳蕤茂盛的自然元素與純淨的幾何線條相結合，珠寶散發著日本文化的精髓。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/japan.js